import { Col, Row } from '@opendoor/atoms/box';
import { Checkbox } from '@opendoor/atoms/checkbox';
import { Text } from '@opendoor/atoms/text';

export interface HomeFeaturesFilterProps {
  noHoas?: boolean | null;
  fhaEligible?: boolean | null;
  mustHavePool?: boolean | null;
  singleStory?: boolean | null;
  handleNoHoasChange: (_: string, checked: string | boolean) => void;
  handleSingleStoryChange?: (_: string, checked: string | boolean) => void;
  handleFhaEligibleChange?: (_: string, checked: string | boolean) => void;
  handlePoolChange: (_: string, checked: string | boolean) => void;
}

export const HomeFeaturesFilter = ({
  noHoas,
  fhaEligible,
  mustHavePool,
  singleStory,
  handleNoHoasChange,
  handleFhaEligibleChange,
  handleSingleStoryChange,
  handlePoolChange,
}: HomeFeaturesFilterProps) => {
  return (
    <Col className="w-full justify-between gap-5">
      <Text as="p" className="self-start text-label-xl text-od-content-primary">
        Home features
      </Text>
      <Row className="items-center justify-between">
        <Text as="p" className="text-body-md text-od-content-primary">
          No HOA Only
        </Text>
        <Checkbox
          aria-label="hoa-checkbox"
          analyticsName="hoa-checkbox"
          id="hoa-checkbox"
          name="hoa"
          value="true"
          checked={!!noHoas}
          onCheckedChange={(checked) => handleNoHoasChange('hoa', checked)}
        />
      </Row>
      {handleSingleStoryChange && (
        <Row className="items-center justify-between">
          <Text as="p" className="text-body-md text-od-content-primary">
            Single-story only
          </Text>
          <Checkbox
            aria-label="single-story-checkbox"
            analyticsName="single-story-checkbox"
            id="single-story-checkbox"
            name="singleStory"
            value="true"
            checked={!!singleStory}
            onCheckedChange={(checked) => handleSingleStoryChange('singleStory', checked)}
          />
        </Row>
      )}
      {handleFhaEligibleChange && (
        <Row className="items-center justify-between">
          <Text as="p" className="text-body-md text-od-content-primary">
            FHA Eligible Only
          </Text>
          <Checkbox
            aria-label="fha-checkbox"
            analyticsName="fha-checkbox"
            id="fha-checkbox"
            name="fha"
            value="true"
            checked={!!fhaEligible}
            onCheckedChange={(checked) => handleFhaEligibleChange('fha', checked)}
          />
        </Row>
      )}
      <Row className="items-center justify-between">
        <Text as="p" className="text-body-md text-od-content-primary">
          With Pool Only (includes community pools)
        </Text>
        <Checkbox
          aria-label="pool-checkbox"
          analyticsName="pool-checkbox"
          id="pool-checkbox"
          name="pool"
          value="true"
          checked={!!mustHavePool}
          onCheckedChange={(checked) => handlePoolChange('pool', checked)}
        />
      </Row>
    </Col>
  );
};
